import BookingStore from '../stores/BookingStore'
import UserStore from '../stores/UserStore'
import ConfigStore from '../stores/ConfigStore'
import DateStore from '../stores/DatesStore'


class BookingUtils {
    constructor() {
        this.bookingStore = BookingStore
        this.configStore = ConfigStore
        this.datesStore = DateStore
        this.performCheckError = ""
    }
    getPerformCheckError() {
        return this.performCheckError
    }
    performChecks(bookingDate, bookings, golfCourse) {
        let success = false
        let message = ""

        const { today } = this.datesStore
        const { userFreeBookings, isRemainingStock, alreadyBooked } = this.bookingStore

        const isAlreadyBooked = alreadyBooked(bookingDate, golfCourse)

        if (!isAlreadyBooked && userFreeBookings > 0) {
            if (bookingDate >= today) {
                if (bookings && bookings.freeSlots === 0) {
                    message = "An diesem Tag sind keine Plätze mehr verfügbar"
                    success = false
                } else {
                    //everything fine
                    success = true
                }

            } else {
                message = "Bitte wählen Sie ein Datum in der Zukunft"
                success = false
            }

        } else {
            if (isAlreadyBooked) {
                if (isRemainingStock(bookingDate)) {
                    message = "Sie können nur " + (UserStore.maxRemainingStockBookings > 1 ? String(UserStore.maxRemainingStockBookings) + " Restplatzbuchungen" : "eine Restplatzbuchung") + " pro Datum pro Golfplatz tätigen."
                    success = false
                } else {
                    message = "Sie können nur " + (UserStore.maxBookingsPerDay > 1 ? String(UserStore.maxBookingsPerDay) + " Buchungen" : "eine Buchung") + " pro Datum pro Golfplatz tätigen."
                    success = false
                }
            } else {
                if (isRemainingStock(bookingDate)) {
                    success = true
                } else {
                    message = "Sie haben momentan keine freien Buchungen"
                    success = false
                }
            }
        }

        this.performCheckError = message
        return success
    }
}

const bookingUtils = new BookingUtils();

export default bookingUtils;


// WEBPACK FOOTER //
// /src/utils/bookingUtils.js